<script setup lang="ts">
import AuthenticatedLayout from '@/Layouts/AuthenticatedLayout.vue';
import { Head, Link } from '@inertiajs/vue3'
import { library } from "@fortawesome/fontawesome-svg-core"
import {  } from "@fal"
import { faCheckCircle, faTimesCircle } from "@fas"

import PageHeading from "@/Components/Headings/PageHeading.vue"
import { capitalize } from "@/Composables/capitalize"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { inject } from "vue"
import { aikuLocaleStructure } from "@/Composables/useLocaleStructure"
import CountUp from 'vue-countup-v3'
import BackgroundBox from '@/Components/BackgroundBox.vue'
import Icon from '@/Components/Utils/Icon.vue'
import { trans } from 'laravel-vue-i18n'
import Image from '@/Components/Utils/Image.vue'
import { layoutStructure } from '@/Composables/useLayoutStructure'
import { useFormatTime } from '@/Composables/useFormatTime'
import { useFormatCurrency } from '@/Composables/useFormatCurrency';
import { useFormatNumber } from '@/Composables/useFormatNumber';
import IconManufacture from '@/Components/Utils/IconManufacture.vue';

library.add(faCheckCircle, faTimesCircle )

const props = defineProps<{
    pageHead?: PageHeadingTS
    title: string
    manufacture: {}
    manufacture_count: number
    stats: {}
}>()
</script>

<template>
    <Head :title />
    <PageHeading :data="pageHead"></PageHeading>
    <!-- <pre>{{ props.manufacture }}</pre> -->

    <div class="mx-8 mt-6 grid lg:grid-cols-2 gap-x-6 gap-y-8 xl:gap-x-6 ">
        <div class="w-full mx-auto max-w-4xl grid grid-cols-1 gap-x-2 gap-y-1.5 sm:grid-cols-2 lg:grid-cols-2">            
            <div v-for="(stat, idxStat) in stats" :key="idxStat"
                class="relative first:col-span-2 first:bg-sky-100 bg-gray-0 px-4 py-6 sm:px-6 lg:first:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">{{ stat.name }}</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stat.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => stat.type == "currency" ? useFormatCurrency(stat.value) : useFormatNumber(value)
                        }' />
                    </span>
                    <IconManufacture v-if="stat.icon" :data="stat.icon" class="top-6 right-3 absolute opacity-70 text-2xl" />

                </p>
            </div>
        </div>
    </div>
</template>
